<template>
  <div id="wrapper">
    <h1>澳新重点领域数据核查</h1>
    <h2>
      <strong>澳新领域</strong>
      <sub>Focus on the indicators</sub>
      <b class="logoline"></b>
      <b class="logoline1"></b>
      <b class="logoline2"></b>
      <b class="logoline3"></b>
      <b class="logoline4"></b>
    </h2>
    <!--时间区-->
    <div class="date-timer">
      <p>
        <strong id="H"></strong>
        <strong>:</strong>
        <strong id="M"></strong>
        <strong id="S" class="hide"></strong>
      </p>
      <em id="D"></em>
      <ul>
        <li id="Y"></li>
        <li id="MH"></li>
        <li id="TD"></li>
      </ul>
    </div>
    <div class="big-index-1">
      <ul>
        <li style="cursor: pointer;" @click="zhSearch(2)">
          <b class="animation-1"></b>
          <b class="animation-2"></b>
          <b class="animation-3"></b>
          <p>重点机构</p>
          <strong style="margin-left:27px;">{{ dataCount.organCount }}</strong>
        </li>
        <li style="cursor: pointer;" @click="zhSearch(3)">
          <b class="animation-1"></b>
          <b class="animation-2"></b>
          <b class="animation-3"></b>
          <p>机构成员</p>
          <strong style="margin-left:18px;">{{ dataCount.personsCount }}</strong>
        </li>
        <li style="cursor: pointer;" @click="zhSearch(4)">
          <b class="animation-1"></b>
          <b class="animation-2"></b>
          <b class="animation-3"></b>
          <p>涉华重点</p>
          <strong style="margin-left:25px;">{{ dataCount.chinaCount }}</strong>
        </li>
        <li>
          <b class="animation-1"></b>
          <b class="animation-2"></b>
          <b class="animation-3"></b>
          <p>关联人员</p>
          <strong style="margin-left:18px;">{{ dataCount.endorsorCount }}</strong>
        </li>
      </ul>
    </div>
    <div class="center-area">
      <div class="pandect-area">
        <h3>
          <strong>新增数据监控</strong>
        </h3>
        <span class="pandect-area-left">
          <b></b>
        </span>
        <div id="main" class="pandect-area-center" style="height:235px;">
          <!-- <img src="images/charts.png" /> -->
        </div>
        <span class="pandect-area-right">
          <b></b>
        </span>
      </div>
      <div class="details1-area">
        <span class="detailsl-area-left"></span>
        <div class="details1-area-center">
          <h3>政府机构</h3>
          <dl>
            <dt style="height: 16px;"></dt>
            <dt style="cursor:pointer;" @click="zkjg_sy(56)">新西兰外交贸易部</dt>
            <dt style="cursor:pointer;" @click="zkjg_sy(57)">新西兰国防部</dt>
            <dt style="cursor:pointer;" @click="zkjg_sy(104)">澳大利亚议会</dt>
            <dt style="cursor:pointer;" @click="zkjg_sy(109)">澳大利亚高等法院</dt>
          </dl>
        </div>
        <span class="detailsl-area-right"></span>
      </div>

      <div class="details2-area">
        <span class="details2-area-left"></span>
        <div class="details2-area-center">
          <h3>咨询公司</h3>
          <dl>
            <dt style="cursor:pointer;" @click="zkjg_sy(59)">新西兰游说公司</dt>
            <dt style="cursor:pointer;" @click="zkjg_sy(58)">澳大利亚霍克布赖顿集团公司</dt>
            <dt style="cursor:pointer;" @click="zkjg_sy(60)">澳大利亚巴顿迪肯公司</dt>
          </dl>
        </div>
        <span class="details2-area-right"></span>
      </div>

      <div class="details3-area">
        <span class="details3-area-left"></span>
        <div class="details3-area-center">
          <h3>情治机构</h3>
          <dl>
            <dt style="cursor:pointer;" @click="zkjg_sy(82)">澳大利亚国防情报组织</dt>
            <dt style="cursor:pointer;" @click="zkjg_sy(113)">澳大利亚地理空间情报组织</dt>
            <dt style="cursor:pointer;" @click="zkjg_sy(81)">澳大利亚安全情报局</dt>
          </dl>
        </div>
        <span class="details3-area-right"></span>
      </div>

      <div class="details4-area">
        <span class="details4-area-left"></span>
        <div class="details4-area-center">
          <h3>澳新媒体</h3>
          <dl>
            <dt style="cursor:pointer;" @click="zkjg_sy(64)">新西兰先驱报</dt>
            <dt style="cursor:pointer;" @click="zkjg_sy(65)">新西兰媒体STUFF</dt>
            <dt style="cursor:pointer;" @click="zkjg_sy(66)">澳大利亚人报</dt>
            <dt style="cursor:pointer;" @click="zkjg_sy(67)">澳大利亚战略家</dt>
            <dt style="cursor:pointer;" @click="zkjg_sy(68)">澳大利亚悉尼先驱晨报</dt>
          </dl>
        </div>
        <span class="details4-area-right"></span>
      </div>

      <div class="details5-area">
        <span class="details5-area-left"></span>
        <div class="details5-area-center">
          <h3>澳新智库</h3>
          <div>
            <div>
              <span style="cursor:pointer;" @click="zkjg_sy(55)">新西兰国际事务研究院</span>
              <span style="cursor:pointer;" @click="zkjg_sy(69)">新西兰智库外交圈</span>
              <span style="cursor:pointer;" @click="zkjg_sy(70)">新西兰经济研究所</span>
              <span style="cursor:pointer;" @click="zkjg_sy(71)">新西兰国防和安全研究中心</span>
              <span style="cursor:pointer;" @click="zkjg_sy(72)">新西兰当代中国研究中心</span>
            </div>
            <div>
              <span style="cursor:pointer;" @click="zkjg_sy(73)">澳大利亚战略政策研究所</span>
              <span style="cursor:pointer;" @click="zkjg_sy(26)">澳大利亚洛伊研究所</span>
              <span style="cursor:pointer;" @click="zkjg_sy(27)">澳大利亚公共事务研究所</span>
              <span style="cursor:pointer;" @click="zkjg_sy(28)">澳大利亚悉尼大学美国研究中心</span>
              <span style="cursor:pointer;" @click="zkjg_sy(30)">澳大利亚东亚论坛</span>
            </div>
            <div>
              <span style="cursor:pointer;" @click="zkjg_sy(31)">澳大利亚战略与国防研究中心</span>
              <span style="cursor:pointer;" @click="zkjg_sy(32)">澳大利亚经济发展委员会</span>
              <span style="cursor:pointer;" @click="zkjg_sy(33)">澳大利亚独立研究中心</span>
              <span style="cursor:pointer;" @click="zkjg_sy(37)">澳大利亚区域安全研究所</span>
              <span style="cursor:pointer;" @click="zkjg_sy(38)">澳大利亚经济与和平研究所</span>
            </div>
            <div>
              <span style="cursor:pointer;" @click="zkjg_sy(39)">澳大利亚中国关系学院</span>
              <span style="cursor:pointer;" @click="zkjg_sy(41)">澳大利亚悉尼研究所</span>
              <span style="cursor:pointer;" @click="zkjg_sy(43)">澳大利亚珀斯美国中心</span>
              <span style="cursor:pointer;" @click="zkjg_sy(49)">澳大利亚格里菲斯亚洲研究所</span>
              <span style="cursor:pointer;" @click="zkjg_sy(54)">澳大利亚发展政策中心</span>
            </div>
          </div>
        </div>
        <span class="details5-area-right"></span>
      </div>
    </div>
    <div class="right-area">
      <h3>
        重点业务导航
        <b></b>
      </h3>
      <div class="area-inbox-1">
        <dl>
          <dt>1.525%</dt>
          <dd class="font12" style="cursor: pointer;" @click="serch('South China Seas,warship,Indo-pacific')">
            <span>南海态势</span>
          </dd>
          <dt class="ml-20">3.113%</dt>
          <dd class="ml-20" style="cursor: pointer;" @click="serch('taiwan')">
            <span>台湾问题</span>
          </dd>
          <dt>0.823%</dt>
          <dd style="cursor: pointer;" @click="serch('Russia-Ukraine,Russia,Ukraine')">
            <span>俄乌局势</span>
          </dd>
        </dl>
        <div class="round-1"></div>
        <div class="round-2"></div>
        <div class="round-3">4.5%</div>
        <div class="round-4"></div>
      </div>
      <h3 style="margin-left: 20px;margin-bottom: 20px;">
        目标推荐
        <b></b>
      </h3>
      <div class="area-inbox-2">
        <ul>
          <li v-for="(p, index) in this.huaPersons" :key="index" @click="rwxq_sy(p.id)">
            <div>
              <img :src="'data:image/png;base64,' + p.imgcode" alt
                style="width:50px;height:100%;border-radius:5px;margin-right:5px;" :onerror="defaultImg" />
            </div>
            <div>
              <strong>{{ p.name }}</strong>
              <em></em>
              <p
                style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">
                {{ p.position }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import "../../static/js/jquery-1.8.3.min.js";
import "../../static/js/common.js";
import echarts from "echarts";
import { getDataCount, getFiveHuaPersons } from "@/api/persons";
export default {
  name: "index",
  data() {
    return {
      dataCount: {
        organCount: 94,
        personsCount: 47267,
        chinaCount: 3837,
        endorsorCount: 26626,
      }, //统计
      huaPersons: [], 
      defaultImg:
        'this.src="' + require("../../static/images/defult_head.png") + '"'
    };
  },
  created() {
    //this.getDataCount(); /*获取统计数字 */
    this.getFiveHuaPersons(); //获取随机推荐的五个涉hua人员
  },
  mounted() {
    this.drawHotField();
  },
  methods: {
    // 绘制数据监控图
    async drawHotField() {
      let myChart = echarts.init(document.getElementById("main"));
      let option;
      option = {
        calculable: true,
        legend: {
          //   指示框名字  注意！要和下方series中的name一起改
          data: ["机构", "人员"],
          // 指示框位置  距离上下左右多少
          right: "3%",
          // top: '50%',
          textStyle: {
            color: "#fff" //字体颜色
          }
        },
        xAxis: {
          type: "category",
          data: [
            "2026-03-03",
            "2026-03-08",
            "2026-03-13",
            "2026-03-18",
            "2026-03-21",
            "2026-03-28",
            "2026-04-02"
          ],
          axisLabel: {
            //x轴文字的配置
            show: true,
            textStyle: {
              color: "#fff"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            //y轴文字的配置
            textStyle: {
              color: "#fff",
              margin: 15
            }
            // formatter: '{value} %'//y轴的每一个刻度值后面加上‘%’号
          }
        },
        markPoint: {
          data: [
            {
              xAxis: 0, //放需要展示图片的x轴索引
              yAxis: 0, //y轴对应的值
              symbol: "aaa"
            },
            {
              xAxis: 1, //放需要展示图片的x轴索引
              yAxis: 0, //y轴对应的值
              symbol: "bbb"
            },
            {
              xAxis: 2, //放需要展示图片的x轴索引
              yAxis: 0, //y轴对应的值
              symbol: "cccc"
            }
          ],
          symbolSize: [20, 20],
          symbolOffset: [0, "-160%"],
          label: {
            show: false
          }
        },

        series: [
          {
            data: [200, 300, 250, 250, 200, 150, 250],
            type: "bar",
            name: "机构",
            itemStyle: {
              normal: {
                color: "red", // 设置线条上点的颜色（和图例的颜色）
                label: {
                  // formatter:,
                  formatter: function (params) {
                    return params.value / 50 + "个";
                  },
                  show: true, //开启显示数值
                  position: "top", //数值在上方显示
                  textStyle: {
                    //数值样式
                    color: "#D1DBFF", //字体颜色
                    fontSize: 14 //字体大小
                  }
                }
              }
            }
          },
          {
            data: [192, 143, 165, 148, 172, 163, 155, 133, 128],
            type: "bar",
            name: "人员",
            itemStyle: {
              normal: {
                color: "#000b73", // 设置线条上点的颜色（和图例的颜色）
                label: {
                  formatter: "{c}" + "人",
                  show: true, //开启显示数值
                  position: "top", //数值在上方显示
                  textStyle: {
                    //数值样式
                    color: "#D1DBFF", //字体颜色
                    fontSize: 14 //字体大小
                  }
                }
              }
            }
          }
        ]
      };
      myChart.setOption(option);
    },

    /*获取统计数字 */
    // async getDataCount() {
    //   this.dataCount = await getDataCount();
    //   // console.log("getDataCount", this.dataCount);
    // },

    /* 获取随机的五个涉hua人员 */
    async getFiveHuaPersons() {
      let personsList = await getFiveHuaPersons();
      this.huaPersons = personsList.data;
      // console.log("getFiveHuaPersons", personsList);
    },

    //跳转人物详情
    rwxq_sy(id) {
      let routeData = this.$router.resolve({
        path: "/rwxq",
        query: { personid: id }
      });
      window.open(routeData.href, "_blank");
    },

    //跳转指定智库机构
    zkjg_sy(id) {
      let routeData = this.$router.resolve({
        path: "/zkjg",
        query: { companyId: id }
      });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: 'zygw', params: { companyId: id }})
    },

    //跳转涉hua重点
    zhSearch(radio) {
      let routeData = this.$router.resolve({
        path: "/zhSearch",
        query: { radio: radio }
      });
      window.open(routeData.href, "_blank");
    },

    //搜索跳转高级检索
    serch(queryContext) {
      let routeData = this.$router.resolve({
        path: "/zhSearch",
        query: { name: queryContext }
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>


<style scoped>
@import "../../static/css/default.css";
@import "../../static/css/mobile.css";
</style>


// WEBPACK FOOTER //
// src/view/index.vue